console.log('PRODUCT-FORM VERSION POPUP-FIXED-MULTI-ITEM');

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
        this.isSubmitting = false;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification');

        if (this.cart && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (typeof evt.stopImmediatePropagation === 'function') {
          evt.stopImmediatePropagation();
        }

        if (this.isSubmitting) return false;
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return false;

        this.isSubmitting = true;
        this.error = false;
        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        try {
          const originalFormData = new FormData(this.form);
          const mainVariantId = originalFormData.get('id');
          const mainQuantity = originalFormData.get('quantity') || '1';

          const sectionId =
            this.dataset.sectionId ||
            this.closest('[data-section]')?.dataset.section ||
            this.closest('product-info')?.dataset.section;

          const upsellCheckbox = sectionId
            ? document.querySelector(`#UpsellCheckbox-${sectionId}`)
            : null;

          const upsellVariantId =
            upsellCheckbox && upsellCheckbox.checked
              ? upsellCheckbox.dataset.upsellVariant
              : null;

          const formData = new FormData();

          if (upsellVariantId) {
            formData.append('items[0][id]', mainVariantId);
            formData.append('items[0][quantity]', mainQuantity);
            formData.append('items[1][id]', upsellVariantId);
            formData.append('items[1][quantity]', '1');

            for (const [key, value] of originalFormData.entries()) {
              if (key === 'id' || key === 'quantity') continue;
              formData.append(key, value);
            }
          } else {
            for (const [key, value] of originalFormData.entries()) {
              formData.append(key, value);
            }
          }

          const cartNotification = document.querySelector('cart-notification');

          if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              cartNotification.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);

            if (typeof cartNotification.setActiveElement === 'function') {
              cartNotification.setActiveElement(document.activeElement);
            }
          }

          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
            },
            body: formData,
          });

          const result = await response.json();
          console.log('ADD RESULT', result);

          if (!response.ok || result.status) {
            console.error('Cart add error:', result);
            this.handleErrorMessage(result.description || 'Något gick fel.');
            this.error = true;
            return false;
          }

          // Fix for multi-item add: /cart/add.js returns "items" instead of "key"
          if (!result.key && Array.isArray(result.items) && result.items.length > 0) {
            result.key = result.items[0].key;
          }

          const cartNotificationEl = document.querySelector('cart-notification');

          if (
            cartNotificationEl &&
            typeof cartNotificationEl.renderContents === 'function' &&
            result.sections &&
            result.key
          ) {
            this.cart = cartNotificationEl;
            cartNotificationEl.renderContents(result);
          } else {
            window.location.href = routes.cart_url;
          }
        } catch (error) {
          console.error('Product form error:', error);
          this.handleErrorMessage('Något gick fel. Försök igen.');
          this.error = true;
        } finally {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }

          if (spinner) spinner.classList.add('hidden');
          this.isSubmitting = false;
        }

        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}